import { render, staticRenderFns } from "./IVF.vue?vue&type=template&id=53bcde70"
import script from "./IVF.vue?vue&type=script&lang=js"
export * from "./IVF.vue?vue&type=script&lang=js"
import style0 from "./IVF.vue?vue&type=style&index=0&id=53bcde70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports